import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { OrderTypeEnums } from 'src/app/enum/order-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { OrderImportModel } from 'src/app/models/imports/order-import';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { OrderDetailService } from 'src/app/services/preliminaries/order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
@Component({
  selector: 'app-import-order-detail',
  templateUrl: './import-order-detail.component.html',
  styleUrls: ['./import-order-detail.component.scss'],
  standalone: false
})
export class ImportOrderDetailComponent implements OnInit {

  eventFile: any;
  errorOrderDetail: number = 0;
  nameFile: string = '';
  orderDetailAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  orderDetailImport: boolean = false;
  suscription: Subscription;
  orderId: number = 0;
  orderTypeId: number = 0;
  visibleTxt: boolean = false;

  constructor(private confirmDialogService: ConfirmDialogService,
    private orderDetailService: OrderDetailService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.orderId = inputs.orderId;
      this.orderTypeId = inputs.orderTypeId;
    });
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.orderDetailImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadGuideImport() {
    this.orderDetailService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaPedidosDetalle.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.orderDetailAlerts || this.orderDetailAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.orderDetailService.exportImportErrors(this.orderDetailAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionArticulosCompuestos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async handleOrderImportWithValidation() {
    if (this.orderTypeId === OrderTypeEnums.rental) {
      const accepted = await this.confirmDialogService.confirm(
        'Los valores unitarios que NO coincidan con los valores de precios por centro de costos serán actualizados según los valores del archivo Excel. ¿Desea iniciar la importación?'
      );
      if (!accepted) {
        this.clearInputFile();
        return;
      }
      this.importOrders();
    } else {
      this.importOrders();
    }
  }


  async importOrders() {
    this.orderDetailAlerts = [];
    this.errorOrderDetail = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      const input = document.getElementById("fileImport") as any;
      if (!input.files[0]) {
        this.clearInputFile();
        return;
      }
      let isOk: boolean = true;
      const rowsImports = new Array<OrderImportModel>();
      let row: OrderImportModel;
      let counter: number = 1, consecutiveOrder: number, articleCode: number,
        articleName: string, quantityInitial: number, unitValue: number;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.');
            this.clearInputFile();
            return;
          }

          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;
            //A. Consecutivo solución:
            const valueOrderConsecutive = element[0];
            if (valueOrderConsecutive == null || valueOrderConsecutive === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del pedido no es válido.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }
            consecutiveOrder = Number(valueOrderConsecutive);
            if (isNaN(consecutiveOrder)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del pedido no es válido.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Artículo:
            const valueArticleCode = element[1];
            if (valueArticleCode == null || valueArticleCode === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }
            articleCode = Number(valueArticleCode);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }

            //C. Nombre Artículo:
            articleName = element[2] as string;
            if (articleName != null && articleName.length > 200) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El nombre del artículo: supera el tamaño máximo de caracteres (200)`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }

            //D. Cantidad
            const valueQuantity = element[3];
            if (valueQuantity == null || valueQuantity === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }
            quantityInitial = Number(valueQuantity);
            if (isNaN(quantityInitial)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
              this.orderDetailAlerts.push(alert);
              rowHasError = true;
            }

            const valueInitialValue = element[4];
            if (valueInitialValue == null || valueInitialValue === "") {
              unitValue = 0; // Asignamos 0 por defecto
            } else {
              unitValue = Number(valueInitialValue);
              if (isNaN(unitValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna E. El Valor no es válido.`;
                this.orderDetailAlerts.push(alert);
                rowHasError = true;
              }
            }

            if (!rowHasError) {
              row = new OrderImportModel(counter, this.orderId,
                consecutiveOrder, articleCode, articleName, quantityInitial, unitValue);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });

          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.orderDetailService.importOrderDetails(rowsImports));

              this.orderDetailAlerts = response?.alerts ?? [];
              this.errorOrderDetail = response?.preInvoicingStateId;
              this.orderDetailImport = true;

              if (this.errorOrderDetail === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR'
                );
              } else if (this.orderDetailAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con alertas, puede exportarlas si lo desea'
                );
              } else {
                this.visibleTxt = false;
                this.orderDetailImport = true;
                this.toastHandlerService.showToast(
                  'success',
                  `La importación terminó exitosamente.`
                );
                this.close();
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.warn('Ningún archivo seleccionado:', error)
            }
            this.clearInputFile();
          } else {
            this.errorOrderDetail = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('success', `No ha seleccionado ningún archivo.`, '');
      }
    }
  }
}

